var api = require("!../src/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../src/node_modules/css-loader/dist/cjs.js!../src/node_modules/sass-loader/dist/cjs.js!./locomotive-scroll.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};